import NextImage from 'next/image';
import env from '@y2/environments';

import styles from './cookie-implementation-title.module.scss';
import text from './cookie-implementation-title.text.json';

export const CookieImplementationTitle = () => (
  <h2 className={styles.title} data-testid="cookie-implementation-title">
    <NextImage
      src={`${env.assets.path}/mango/cookies-constant-emoji.png`}
      alt={text.altPic}
      width={24}
      height={24}
    />
    <span>{text.title}</span>
  </h2>
);
